import PropTypes from 'prop-types';
import React from 'react';

import Confirm from 'common/components/Confirm';

import styles from './PrivacyPolicyModal.css';

const POLICY_URL = 'https://transloc.com/terms-of-use-privacy-policy/';

const PrivacyPolicyModal = ({checked, onAccept, onCheckboxToggle}) => {
  const message = (
    <div className={styles.message}>
      <div>
        Our privacy policy has recently changed. Please read and agree to the updated policy.
      </div>
      <div>
        <input
          className={styles.checkbox}
          type="checkbox"
          checked={checked}
          onChange={onCheckboxToggle}
        />
        I have read and agreed to the updated
        {' '}
        <a href={POLICY_URL} target="_blank">Privacy Policy</a>
        .
      </div>
    </div>
  );

  return (
    <Confirm
      confirmButtonText="Agree"
      title="Privacy Policy"
      message={message}
      hideCancel
      hideConfirm={!checked}
      onConfirm={onAccept}
      open
    />
  );
};

PrivacyPolicyModal.propTypes = {
  checked: PropTypes.bool,
  onAccept: PropTypes.func,
  onCheckboxToggle: PropTypes.func,
};

export default PrivacyPolicyModal;



// WEBPACK FOOTER //
// ./src/ondemand/components/PrivacyPolicyModal/PrivacyPolicyModal.js